/**
 * UsageContent - 食用方法渲染组件
 */

import React from 'react';
import { getProxyUrl } from '../../utils/urlProxy';

export default function UsageContent({ data, mode = 'view', templateType }) {
  if (!data) return null;

  const normalizeHtml = (html) => {
    if (!html || typeof html !== 'string') return '';
    return html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
  };
  const hasTitleContent = !!normalizeHtml(data.title);
  const hasVideo = !!data.video;
  const hasBodyContent = hasTitleContent || hasVideo; // 有正文/视频才渲染内容块

  const isStandardTemplate = templateType === 'standard-food-label';
  const isBlueWhiteTemplate = templateType === 'blue-white-template';

  // 获取标题配置
  const titleConfig = data.titleConfig || {};
  const shouldShowCustomTitle = titleConfig.enabled && (titleConfig.chinese || titleConfig.english);

  // 根据模板类型设置默认颜色
  const defaultBgColor = isBlueWhiteTemplate ? '#1e90ff' : (isStandardTemplate ? '#5C4A37' : undefined);
  const defaultTextColor = (isBlueWhiteTemplate || isStandardTemplate) ? '#ffffff' : undefined;

  // 渲染标题
  const renderTitle = () => {
    if (shouldShowCustomTitle) {
      const baseClass = isBlueWhiteTemplate ? 'content-section-heading blue-white-title' : 'content-section-heading';
      return (
        <h3
          className={baseClass}
          style={{
            backgroundColor: titleConfig.bgColor || defaultBgColor,
            color: titleConfig.textColor || defaultTextColor
          }}
        >
          {titleConfig.english && (
            <div className="blue-white-title-en">{titleConfig.english}</div>
          )}
          <div className="blue-white-title-cn">{titleConfig.chinese || '食用方法'}</div>
        </h3>
      );
    }

    if (isStandardTemplate || isBlueWhiteTemplate) {
      return <h3 className="content-section-heading">食用方法</h3>;
    }

    return null;
  };

  const bodyStyleBase = (customStyles = {}) => {
    // 无正文时去掉填充与背景，避免出现“空蓝块”
    if (hasVideo && !hasTitleContent) {
      return {
        padding: 0,
        background: 'transparent',
        backgroundColor: 'transparent',
        ...customStyles
      };
    }
    return customStyles;
  };

  if (isBlueWhiteTemplate) {
    // 如果用户设置了背景色，优先使用用户设置的颜色，覆盖CSS默认值
    const bgColor = data.backgroundColor && data.backgroundColor !== 'transparent' 
      ? data.backgroundColor 
      : undefined;
    
    return (
      <>
        {renderTitle()}
        {hasBodyContent && (
          <div 
            className="label-content-usage" 
            style={bodyStyleBase({ 
              backgroundColor: bgColor || undefined,
              background: bgColor || undefined  // 使用background确保覆盖CSS中的background属性
            })}
          >
            {hasTitleContent && (
              <div className="usage-title" dangerouslySetInnerHTML={{ __html: data.title }} />
            )}
            {hasVideo && (() => {
              const videoUrl = typeof data.video === 'string' ? data.video : data.video.url;
              const proxyVideoUrl = getProxyUrl(videoUrl);
              const posterUrl = data.videoOptions && data.videoOptions.poster ? getProxyUrl(data.videoOptions.poster) : undefined;
              return (
                <video
                  src={proxyVideoUrl}
                  className="usage-video"
                  controls={(data.videoOptions ? data.videoOptions.controls !== false : true)}
                  autoPlay={!!(data.videoOptions && data.videoOptions.autoplay)}
                  muted={!!(data.videoOptions && data.videoOptions.muted)}
                  loop={!!(data.videoOptions && data.videoOptions.loop)}
                  poster={posterUrl}
                  style={{
                    borderRadius: data.videoStyle && data.videoStyle.radius ? data.videoStyle.radius : 0,
                    border: data.videoStyle && data.videoStyle.borderWidth ? `${data.videoStyle.borderWidth}px solid ${data.videoStyle.borderColor || '#e8eaed'}` : 'none',
                    height: data.videoStyle && data.videoStyle.height ? data.videoStyle.height : undefined
                  }}
                  onError={(e) => {
                    console.error('视频加载失败:', videoUrl);
                  }}
                />
              );
            })()}
          </div>
        )}
      </>
    );
  }
  return (
    <>
      {(isStandardTemplate || isBlueWhiteTemplate) && renderTitle()}
      {hasBodyContent && (
        <div
          className="label-content-usage"
          style={bodyStyleBase({
            backgroundColor: (isStandardTemplate || isBlueWhiteTemplate) ? undefined : (data.backgroundColor || undefined)
          })}
        >
          {hasTitleContent && (
            <div
              className="usage-title"
              dangerouslySetInnerHTML={{ __html: data.title }}
              style={{
                // 如果设置了深色背景（非标准/蓝白模板），使用白色文字
                color: (!isStandardTemplate && !isBlueWhiteTemplate && data.backgroundColor && data.backgroundColor !== 'transparent')
                  ? '#ffffff'
                  : undefined
              }}
            />
          )}
          {hasVideo && (
            <video
              src={typeof data.video === 'string' ? data.video : data.video.url}
              className="usage-video"
              controls={(data.videoOptions ? data.videoOptions.controls !== false : true)}
              autoPlay={!!(data.videoOptions && data.videoOptions.autoplay)}
              muted={!!(data.videoOptions && data.videoOptions.muted)}
              loop={!!(data.videoOptions && data.videoOptions.loop)}
              poster={data.videoOptions && data.videoOptions.poster ? data.videoOptions.poster : undefined}
              style={{
                borderRadius: data.videoStyle && data.videoStyle.radius ? data.videoStyle.radius : 0,
                border: data.videoStyle && data.videoStyle.borderWidth ? `${data.videoStyle.borderWidth}px solid ${data.videoStyle.borderColor || '#e8eaed'}` : 'none',
                height: data.videoStyle && data.videoStyle.height ? data.videoStyle.height : undefined
              }}
            />
          )}
        </div>
      )}
    </>
  );
}
